import AMLHistoryBlock from './AMLHistoryBlock';

export default AMLHistoryBlock;
